// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  width: 100%;
}

body::ng-deep {
  overflow-y: hidden !important;
}

.chat-header {
  height: 50px;
}

.chat-header, .chat-content {
  width: 100%;
  display: flex;
  justify-content: space-evenly;
}

.wrapper {
  display: flex;
  height: 100%;
  flex-direction: row;
  justify-content: stretch;
}

.chat-sidebar {
  max-width: 320px;
  height: 100%;
  background: #fff;
  box-shadow: rgba(0, 0, 0, 0.15) 1.95px 0px 2.6px;
}

.chatBotstyle {
  display: flex;
  flex-direction: row;
  width: 100% !important;
  height: 100%;
}

.hide {
  display: none;
}

.fa {
  cursor: pointer;
}

.chat-box-wrapper {
  position: relative;
  display: flexbox;
  width: 90%;
}

.chat-left-content {
  background: #fff;
  min-width: 280px;
  overflow-y: auto;
  /* box-shadow:2px 0px 0px rgba(0, 0, 0, 0.21); */
  /* box-shadow:3px 0px #e9e9e9; */
}

.chat-right-content {
  /* margin-left:20px; */
  /* width: clamp(300px,150vw,70vw); */
  min-width: 70%;
  width: 100%;
  overflow-y: auto;
  display: flex;
  justify-content: space-evenly;
}

#title {
  display: flex;
  flex-direction: row;
  align-items: baseline;
  justify-content: space-evenly;
  margin: 10px 0px;
  font-size: 16px;
  font-weight: bold;
}

.chat-history-list {
  height: 80vh;
  overflow-y: auto;
}

.chat-history-list ul {
  margin: 10px 0px;
  padding: 0px 10px;
  list-style: none;
  display: flex;
  flex-direction: column;
  line-height: 1.2rem;
}
.chat-history-list ul li {
  display: inline-flex;
  justify-content: space-evenly;
  align-items: baseline;
}
.chat-history-list ul li label:first-child {
  display: inline-block;
  background: #eee;
  color: #666;
  border-radius: 10px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
  font-size: 0.9rem;
  min-height: 25px;
  padding: 10px 10px;
  margin-bottom: 10px;
  width: 90%;
}
.chat-history-list ul li label:last-child {
  margin: 0% 3%;
  display: inline-block;
  width: 5%;
  padding-left: 2%;
}

#chat-list-content {
  margin: auto;
  width: 60%;
  padding: 0% 2%;
  font-size: 0.9rem !important;
}

#chat-list {
  position: relative;
  overflow-y: auto;
  width: 95%;
  height: 80vh;
  padding-right: 5px;
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}

#chat-list::-webkit-scrollbar {
  display: none;
}

.chat-list-row {
  display: flex;
  flex-direction: column;
  width: 100%;
  position: relative;
  padding: 0px 0px;
}

#chat-message-enter-box {
  /* position: fixed; */
  background: #fff;
  width: 60%;
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  align-items: center;
  border-radius: 5px;
  box-shadow: rgba(0, 0, 0, 0.35) 0px 1px 5px;
  z-index: 1;
  /* top:65px; */
}
#chat-message-enter-box form {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  width: 100%;
}
#chat-message-enter-box textarea {
  width: 100% !important;
  border: none;
  padding: 10px;
  color: #666;
  font-size: 1em;
  resize: none;
  height: 55px;
}
#chat-message-enter-box span {
  display: inline-block;
  color: #666;
  width: 100% !important;
  padding: 10px;
  color: #666;
  font-size: 1em;
  min-height: 55px;
}

/* .chat-header > span{
    display: inline-block;
        color: #666;
        width: 90% !important;
        padding: 10px;
        color: #666;
        font-size:1em;
        min-height:100px;
} */
.fa-cloud, .fa-user-circle {
  color: #9da0a3;
  margin-top: 5px;
  font-size: 30px !important;
}

app-toggle-icon::ng-deep .fa-microphone-slash, .fa-microphone-slash {
  opacity: 0.5 !important;
}

textarea::placeholder {
  color: rgb(182, 182, 182) !important;
}

.question {
  /* background: #9da0a3;   */
  /* background: #01488f; */
  min-height: 50px;
  padding: 15px 10px;
  background: #fff;
  color: #000;
  font-weight: bold;
  margin-bottom: 2px;
  width: 100%;
  position: relative;
  box-shadow: rgba(14, 63, 126, 0.06) 0px 0px 0px 1px, rgba(42, 51, 70, 0.03) 0px 1px 1px -0.5px, rgba(42, 51, 70, 0.04) 0px 2px 2px -1px, rgba(42, 51, 70, 0.04) 0px 3px 3px -1.5px, rgba(42, 51, 70, 0.03) 0px 5px 5px -2.5px, rgba(42, 51, 70, 0.03) 0px 10px 10px -5px, rgba(42, 51, 70, 0.03) 0px 24px 24px -8px;
  /* box-shadow: 2px 2px 3px #000; */
  /* box-shadow: rgba(25, 118, 210, 0.35) 0px 5px 15px; */
  /* box-shadow: rgba(109, 129, 153, 0.35) 0px 5px 15px; */
}

/* .question::before{
    content: " ";
    position: absolute;
    width: 0;
    height: 0;
    left:-15px;
    right:auto;
    top:10px;
    bottom: auto;
    border:15px solid;
    border-color:var(--primaryColor) transparent transparent transparent;


} */
.question.align-right {
  /* background: #f2fcff; */
  background: #9da0a3;
  min-height: 50px;
  border-radius: 5px;
  padding: 10px;
  color: #fff;
  margin-bottom: 10px;
  width: 100%;
  margin-left: 50%;
  margin-right: 15px;
  position: relative;
}

.question.align-right::before {
  content: " ";
  position: absolute;
  width: 0;
  height: 0;
  left: auto;
  right: -20px;
  top: 0px;
  bottom: auto;
  border: 21px solid;
  border-color: #848a92 transparent transparent transparent;
}

video {
  margin: 10px 0px;
}

.answer {
  background: #fff;
  min-height: 50px;
  padding: 10px;
  color: #666;
  display: flex;
  flex-direction: column;
  width: 100%;
  /* box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px; */
  box-shadow: rgba(14, 63, 126, 0.04) 0px 0px 0px 1px, rgba(42, 51, 69, 0.04) 0px 1px 1px -0.5px, rgba(42, 51, 70, 0.04) 0px 3px 3px -1.5px, rgba(42, 51, 70, 0.04) 0px 6px 6px -3px, rgba(14, 63, 126, 0.04) 0px 12px 12px -6px, rgba(14, 63, 126, 0.04) 0px 24px 24px -12px;
}

.answer-header {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  padding-right: 10px;
  gap: 15px;
  min-height: 30px;
  padding-top: 5px;
  background: #fff;
}
.answer-header span {
  font-weight: bold;
}

.audio {
  cursor: pointer;
}

ul li {
  display: inline;
  list-style: none;
  margin: 5px 10px;
  display: inline-block;
  cursor: pointer;
}

.menu-list {
  position: relative;
}
.menu-list ul {
  position: absolute;
  top: -10px;
  right: 0px;
  width: max-content;
}
.menu-list ul li {
  margin: 10px 10px;
  display: inline-block;
  cursor: pointer;
}
.menu-list ul li:hover .fa {
  color: #008cb3;
}
.menu-list ul.active {
  display: block;
}
.menu-list label {
  width: 20px;
  display: flex;
  justify-content: center;
  cursor: pointer;
}

.dropdown-menu {
  left: -55px !important;
}

.dropdown-item {
  padding: 0px !important;
}
.dropdown-item li {
  margin: 5px 0px !important;
  font-size: 12px !important;
  width: 100%;
  padding: 5px 10px;
}
.dropdown-item li:hover {
  background: var(--primarylightColor);
  color: var(--primaryColor);
}

/*.answer-content::before{
    content: " ";
    position: absolute;
    width: 0;
    height: 0;
    left:-25px;
    right:auto;
    top:-25px;
    bottom: auto;
    border: 21px solid;
    border-color: #fff transparent transparent transparent;

} */
.answer-content {
  position: relative;
  padding: 10px 5px;
  line-height: 1.6;
  font-size: 0.9rem;
  color: #111;
}

.answer-content::ng-deep ol {
  padding: 10px !important;
}

.feedback::before {
  content: " ";
  position: absolute;
  width: 0;
  height: 0;
  left: -25px;
  right: auto;
  top: 0px;
  bottom: auto;
  border: 21px solid;
  border-color: #fff transparent transparent transparent;
}

.feedback {
  position: relative;
  color: #111;
}
.feedback ol {
  padding: 30px;
}

.chat-icon {
  width: 35px;
  height: 35px;
  border-radius: 100%;
  background: var(--primarylightColor);
}
.chat-icon .bot-icon {
  margin-top: 5px;
}
.chat-icon img {
  border-radius: 100%;
}

.username {
  width: 36px;
  height: 36px;
  border-radius: 100%;
  background: var(--primarylightColor);
  color: var(--primaryColor);
  vertical-align: middle;
  text-align: center;
  font-size: 22px;
  margin-right: 5px;
  display: inline-block;
  text-transform: uppercase;
}

#chatForm {
  width: 100%;
  height: inherit;
  padding: 10px 10px;
}

#chatForm > span {
  width: 90%;
  height: inherit;
  margin-left: 10px;
}

#expand-collapse {
  position: relative;
  margin-top: 25px;
  height: 15px;
}
#expand-collapse i {
  background: #fff;
  padding: 10px;
}
#expand-collapse .fa {
  font-size: 1.5em !important;
  transform: rotate(180deg) translateX(0px);
  transform-origin: 50% 20%;
}

::-webkit-scrollbar {
  width: 3px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #fff;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #fff;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #fff;
}

#chat-content-wrapper {
  display: flex;
  justify-content: space-around;
  width: 100%;
  flex-direction: column;
}
#chat-content-wrapper header {
  background: transparent !important;
  padding: 5px !important;
}

.chat-history-list::ng-deep .tabs-container {
  height: 80vh !important;
}
.chat-history-list::ng-deep .tabs-container ul {
  display: flex;
}
.chat-history-list::ng-deep .tabs-container li {
  width: 50%;
  font-size: 0.9em;
}
.chat-history-list::ng-deep .tabs-container app-tab .pane {
  padding: 0px !important;
}
.chat-history-list::ng-deep .tabs-container app-tab li {
  width: 100%;
}

#voice-message {
  width: 80% !important;
  position: relative;
  background: #fff;
  margin-top: -50px;
  margin-left: 10px;
  padding-right: 10px;
  height: 50px;
}
#voice-message span {
  display: inline-block;
  color: #999;
}

#chat-tools {
  display: flex;
  list-style-type: none;
  width: 60px;
  flex-direction: row;
  gap: 20px;
  padding: 0px;
  margin: 0px;
  position: relative;
  right: 10px;
}
#chat-tools .fa-paper-plane {
  font-size: 17px !important;
}

[hidden] {
  display: none !important;
}

.comment-area-box::after {
  content: "";
  position: absolute;
  width: 0;
  height: 0;
  top: 1px;
  left: 99%;
  box-sizing: border-box;
  border: 10px solid rgba(0, 0, 0, 0.5);
  border-color: transparent transparent #fff #fff;
  transform-origin: 0 0;
  transform: rotate(135deg);
  box-shadow: -1px 1px 1px 0 rgba(0, 0, 0, 0.35);
}

.comment-area-box {
  display: none;
  background: #fff;
  padding: 15px 10px 5px;
  width: 80%;
}
.comment-area-box label {
  width: -moz-fit-content !important;
  width: fit-content !important;
}
.comment-area-box textarea {
  resize: none;
}
.comment-area-box .form-btns {
  width: 100%;
  display: flex;
  margin: 5px 0px;
}
.comment-area-box .form-btns .btn:first-child {
  border: 1px solid #dbdbdb;
  background: #fff !important;
  color: #000 !important;
}
.comment-area-box .form-btns .btn {
  --bs-btn-line-height:1.2 !important;
  font-size: 0.9rem !important;
  padding: 5px 20px;
  color: #fff;
  background: var(--primaryColor);
  margin-right: 15px;
  border: none;
  cursor: pointer;
  font-family: "Noto Sans", sans-serif;
}

.comment-area-box.is-active {
  display: flex;
  margin-top: 10px;
  align-items: center;
}

.comment-form {
  margin-left: 10px;
  margin-top: 10px;
}
.comment-form label {
  font-size: 0.9rem;
}
.comment-form textarea {
  margin-right: 25px;
}
.comment-form .comments-field {
  margin-top: 10px;
}
.comment-form .comments-field .form-btns {
  float: right;
}
.comment-form .button:hover {
  background: var(--primaryColor) !important;
  color: #fff !important;
}

.chat-icon:has(> .bot-icon) {
  position: sticky;
  top: 0;
  margin-bottom: 40px;
}

@media screen and (max-width: 640px) {
  .chat-icon:has(> .bot-icon) {
    position: sticky;
    top: 0;
    margin-bottom: 40px;
  }
  .chat-list-row {
    width: 98%;
  }
  .answer-header {
    justify-content: flex-end;
  }
  .menu-list {
    margin-top: 10px;
  }
}
@media screen and (min-width: 768px) and (max-width: 960px) {
  #chat-list-content {
    padding: 1% 3% 0% 1% !important;
  }
}
#botWrapper {
  display: flex;
  width: 100%;
  position: relative;
  justify-content: center;
  padding: 0px 5px;
}

body::ng-deep {
  overflow-y: hidden !important;
}

.second-level-menu {
  background: transparent !important;
  min-width: auto !important;
  max-width: 350px !important;
}

header {
  border-left: 0px !important;
  height: auto !important;
}

.chat-header {
  height: auto;
  justify-content: center;
  margin-top: 10px;
  position: relative;
  display: flex;
  padding: 0% 1%;
}

.chat-header, .chat-content {
  width: 100%;
  display: flex;
  margin: 10px auto;
}

#botinput-wrapper ul.dropdown-menu, #chat-list-content ul.dropdown-menu {
  box-shadow: rgba(0, 0, 0, 0.05) 0px 0px 0px 1px;
}
#botinput-wrapper ul.dropdown-menu li, #chat-list-content ul.dropdown-menu li {
  display: flex;
  align-items: center;
  padding-left: 10px;
  color: #666;
  height: 30px;
  cursor: pointer;
}
#botinput-wrapper ul.dropdown-menu li:hover, #chat-list-content ul.dropdown-menu li:hover {
  background: #f1f1f1;
}

#chat-list-content ul.dropdown-menu li {
  gap: 10px;
}

.chat-content {
  width: 90%;
  justify-content: space-evenly;
}

.wrapper {
  display: flex;
  height: 100%;
  flex-direction: row;
  justify-content: stretch;
}

.chat-sidebar {
  max-width: 320px;
  height: 100%;
  background: #fff;
  box-shadow: rgba(0, 0, 0, 0.15) 1.95px 0px 2.6px;
}

.chatBotstyle {
  display: flex;
  flex-direction: row;
  width: 100% !important;
  height: 100%;
}

.hide {
  display: none;
}

.fa {
  cursor: pointer;
}

.chat-box-wrapper {
  position: relative;
  display: flexbox;
  width: 90%;
}

.chat-left-content {
  background: #fff;
  min-width: 280px;
  overflow-y: auto;
  /* box-shadow:2px 0px 0px rgba(0, 0, 0, 0.21); */
  /* box-shadow:3px 0px #e9e9e9; */
}

.chat-right-content {
  /* margin-left:20px; */
  /* width: clamp(300px,150vw,70vw); */
  min-width: 70%;
  width: 100%;
  overflow-y: auto;
  display: flex;
  justify-content: space-evenly;
}

#title {
  display: flex;
  flex-direction: row;
  align-items: baseline;
  justify-content: space-evenly;
  margin: 10px 0px;
  font-size: 16px;
  font-weight: bold;
}

.chat-history-list {
  height: 100vh;
  background: rgba(0, 0, 0, 0.1);
  width: 100%;
  margin-left: 0px;
  position: absolute;
  z-index: 9;
  right: 0px;
  top: 0px;
}
.chat-history-list .listing-data {
  height: 90vh;
  overflow-y: auto;
  background: #fff;
  padding-bottom: 1.5em;
  padding-left: 0.5rem;
}
.chat-history-list .listing-data.templatesection {
  height: 100vh;
}
.chat-history-list .audio-wrapper {
  position: absolute;
  z-index: 999;
  right: -2rem;
  background: rgba(0, 0, 0, 0.5);
}
.chat-history-list .audio-wrapper.is-active {
  display: block;
}

::ng-deep .audio-file-class {
  width: 100%;
  min-width: 300px;
}

.chat-history-list ul {
  margin: 10px 0px;
  padding: 0px 10px;
  list-style: none;
  display: flex;
  flex-direction: column;
  line-height: 1.2rem;
}
.chat-history-list ul li {
  display: inline-flex;
  justify-content: space-evenly;
  align-items: baseline;
  border-bottom: 1px solid var(--bodyBgColor) !important;
  color: #000 !important;
}
.chat-history-list ul li label:first-child {
  display: inline-block;
  border-radius: 10px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
  font-size: 0.9rem;
  min-height: 25px;
  padding: 10px 10px;
  margin-bottom: 10px;
  width: 90%;
}
.chat-history-list ul li label:last-child {
  margin: 0% 3%;
  display: inline-block;
  width: 5%;
  padding-left: 2%;
}

#chat-list-content {
  position: relative;
  width: 100%;
  display: flex;
  justify-content: flex-start;
  max-width: 960px;
  font-size: 0.9rem !important;
  max-height: calc(100vh - 280px);
  overflow-y: auto;
  scrollbar-width: none;
  flex-direction: column;
}

#chat-list {
  width: 100%;
  display: inline-block;
  margin-left: 0rem;
  padding-bottom: 5%;
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}

#chat-list::-webkit-scrollbar {
  display: none;
}

.chat-list-row {
  display: flex;
  flex-direction: row;
  width: 100%;
  max-width: 960px;
}

#chat-message-enter-box {
  background: #fff;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  align-items: center;
  border-radius: 5px;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px;
  z-index: 1;
}
#chat-message-enter-box form {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  width: 100%;
}
#chat-message-enter-box textarea {
  width: 100% !important;
  border: none;
  padding: 10px;
  color: #666;
  font-size: 1em;
  resize: none;
  height: 55px;
}
#chat-message-enter-box span {
  display: inline-block;
  color: #666;
  width: 100% !important;
  padding: 10px;
  color: #666;
  font-size: 1em;
  min-height: 40px;
}

/* .chat-header > span{
    display: inline-block;
        color: #666;
        width: 90% !important;
        padding: 10px;
        color: #666;
        font-size:1em;
        min-height:100px;
} */
.fa-cloud, .fa-user-circle {
  color: #9da0a3;
  margin-top: 5px;
  font-size: 30px !important;
}

app-toggle-icon::ng-deep .fa-microphone-slash, .fa-microphone-slash {
  opacity: 0.5 !important;
}

textarea::placeholder {
  color: rgb(182, 182, 182) !important;
}

.question {
  background: #848a92;
  /* background: #9da0a3;   */
  /* background: #01488f; */
  min-height: 50px;
  border-radius: 5px;
  padding: 10px;
  color: #fff;
  margin-bottom: 10px;
  width: 100%;
  margin-left: 20px;
  position: relative;
  /* box-shadow: 2px 2px 3px #000; */
  /* box-shadow: rgba(25, 118, 210, 0.35) 0px 5px 15px; */
  /* box-shadow: rgba(109, 129, 153, 0.35) 0px 5px 15px; */
}

.question::before {
  content: " ";
  position: absolute;
  width: 0;
  height: 0;
  left: -20px;
  right: auto;
  top: 0px;
  bottom: auto;
  border: 21px solid;
  border-color: #848a92 transparent transparent transparent;
  /* border-color: #9da0a3 transparent transparent transparent;  */
  /* border-color:#01488f transparent transparent transparent; */
}

.question.align-right {
  /* background: #f2fcff; */
  background: #9da0a3;
  min-height: 50px;
  border-radius: 5px;
  padding: 10px;
  color: #fff;
  margin-bottom: 10px;
  width: 100%;
  margin-left: 50%;
  margin-right: 15px;
  position: relative;
}

.question.align-right::before {
  content: " ";
  position: absolute;
  width: 0;
  height: 0;
  left: auto;
  right: -20px;
  top: 0px;
  bottom: auto;
  border: 21px solid;
  border-color: #848a92 transparent transparent transparent;
}

video {
  margin: 10px 0px;
}

.answer {
  background: #fff;
  min-height: 50px;
  border-radius: 5px;
  padding: 10px;
  color: #666;
  margin-bottom: 30px;
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-left: 19px;
  /* box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px; */
}
.answer .answer-header {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  padding-right: 10px;
  gap: 15px;
}
.answer .audio {
  cursor: pointer;
}
.answer .menu-list {
  position: relative;
}
.answer .menu-list ul {
  position: absolute;
  /* background: #f5fdff; */
  /* padding: 10px; */
  /* z-index: 9999; */
  top: -10px;
  right: 0px;
  width: max-content;
  /* box-shadow: 3px 3px #008cb3;
  border-radius:5px;
  border: 1px solid #95bdc7; */
}
.answer .menu-list ul li {
  margin: 10px 10px !important;
  display: inline-block;
  cursor: pointer;
  /* .fa{
   color: #008cb3;
  } */
}
.answer .menu-list ul li:hover .fa {
  color: #008cb3;
}
.answer .menu-list ul.active {
  display: block;
}
.answer .menu-list label {
  width: 20px;
  display: flex;
  justify-content: center;
  cursor: pointer;
}

.answer-content::before {
  content: " ";
  position: absolute;
  width: 0;
  height: 0;
  left: -32px;
  right: auto;
  top: -35px;
  bottom: auto;
  border: 21px solid;
  border-color: #fff transparent transparent transparent;
}

.answer-content {
  position: relative;
  margin-top: 25px;
}
.answer-content ol {
  padding: 30px;
}

.chat-icon {
  width: 32px;
  height: 32px;
  border-radius: 100%;
  background: #d2daf3;
}
.chat-icon img {
  border-radius: 100%;
}

.username {
  width: 36px;
  height: 36px;
  border-radius: 100%;
  background: #d2daf3;
  color: #133aa5;
  vertical-align: middle;
  text-align: center;
  font-size: 22px;
  margin-right: 5px;
  display: inline-block;
  text-transform: uppercase;
}

#chatForm {
  width: 100%;
  height: inherit;
}

#chatForm > span {
  width: 90%;
  height: inherit;
  margin-left: 10px;
}

#expand-collapse {
  position: relative;
  margin-top: 25px;
  height: 15px;
}
#expand-collapse i {
  background: #fff;
  padding: 7px;
}
#expand-collapse .fa {
  font-size: 1.5em !important;
  transform: rotate(180deg) translateX(0px);
  transform-origin: 50% 20%;
}

#expand-collapse-right {
  position: relative;
  height: 15px;
}
#expand-collapse-right i {
  background: #fff;
  padding: 7px;
}
#expand-collapse-right .fa {
  font-size: 1.5em !important;
  transform: rotate(0deg) translateX(0px);
  transform-origin: 50% 20%;
}

::-webkit-scrollbar {
  width: 3px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #fff;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #fff;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #fff;
}

#chat-content-wrapper header {
  background: transparent !important;
  padding: 5px !important;
}

#voice-message {
  width: 80% !important;
  position: relative;
  background: #fff;
  margin-top: -40px;
  margin-left: 10px;
  padding-right: 10px;
  height: 40px;
}
#voice-message span {
  display: inline-block;
  color: #999;
}

#chat-tools {
  display: flex;
  list-style-type: none;
  width: auto;
  flex-direction: row;
  gap: 20px;
  padding: 0px;
  margin: 0px;
  position: relative;
  right: 10px;
  top: 5px;
  /* Rounded sliders */
}
#chat-tools .fa-paper-plane {
  font-size: 17px !important;
}
#chat-tools .switch {
  position: relative;
  display: inline-block;
  width: 35px;
  height: 20px;
}
#chat-tools .switch span {
  min-height: 20px;
}
#chat-tools .switch input {
  opacity: 0;
  width: 0;
  height: 0;
}
#chat-tools .slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: 0.4s;
}
#chat-tools .slider:before {
  position: absolute;
  content: "";
  height: 15px;
  width: 15px;
  left: 4px;
  bottom: 3px;
  background-color: white;
  transition: 0.4s;
}
#chat-tools input:checked + .slider {
  background-color: var(--primaryColor);
}
#chat-tools input:focus + .slider {
  box-shadow: 0 0 1px #2196F3;
}
#chat-tools input:checked + .slider:before {
  transform: translateX(13px);
}
#chat-tools .slider.round {
  border-radius: 34px;
}
#chat-tools .slider.round:before {
  border-radius: 50%;
}

[hidden] {
  display: none !important;
}

.comment-area-box::after {
  content: "";
  position: absolute;
  width: 0;
  height: 0;
  top: 1px;
  left: 99%;
  box-sizing: border-box;
  border: 10px solid rgba(0, 0, 0, 0.5);
  border-color: transparent transparent #fff #fff;
  transform-origin: 0 0;
  transform: rotate(135deg);
  box-shadow: -1px 1px 1px 0 rgba(0, 0, 0, 0.35);
}

.comment-area-box {
  position: absolute;
  z-index: 999;
  top: 40px;
  right: 0px;
  display: none;
  background: #fff;
  padding: 20px 40px;
  box-shadow: rgba(0, 0, 0, 0.35) 0px 1px 5px;
  width: 300px;
}
.comment-area-box label {
  width: -moz-fit-content !important;
  width: fit-content !important;
}
.comment-area-box textarea {
  resize: none;
}
.comment-area-box .form-btns {
  width: 100%;
  display: flex;
  margin: 10px 0px;
}
.comment-area-box .form-btns .btn:first-child {
  border: 1px solid #dbdbdb;
  background: #fff !important;
  color: #000 !important;
}
.comment-area-box .form-btns .btn {
  --bs-btn-line-height:1.2 !important;
  font-size: 0.9rem !important;
  padding: 5px 20px;
  color: #fff;
  background: #133aa5;
  margin-right: 15px;
  border: none;
  cursor: pointer;
  font-family: "Noto Sans", sans-serif;
}

.comment-area-box.is-active {
  display: block;
}

.select:not(.is-multiple):not(.is-loading)::after {
  right: 1.5em;
  z-index: 4;
  top: 15px;
  font-size: 12px;
}

.dropdown-list {
  display: block;
  border-radius: 5px;
  display: block;
  height: 30px;
  padding: 5px;
  border: 1px solid gray;
}

.dropdown-list.show {
  display: block;
}

.toggle-button {
  display: block;
  margin-bottom: 10px;
}

#right-side-panel {
  width: 20%;
  background: #fff;
  box-shadow: 0px 0px 4px #b2b2b2;
  padding: 10px;
}

#designlist {
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: 10px;
}
#designlist label {
  font-size: 14px;
  font-weight: bold;
}

#designlist li {
  list-style: none;
  margin: 10px;
  white-space: nowrap;
  border: 1px solid #dcd8d8;
  color: #222222;
  cursor: pointer;
  width: 100%;
  height: 100px;
  overflow: hidden;
}
#designlist li.active {
  border: 2px dashed var(--primaryColor);
}

@media screen and (min-width: 768px) {
  .toggle-button {
    display: none;
    /* Hide button for larger screens */
  }
  .mobile-close-btn {
    display: none;
  }
}
.dropdown-trigger {
  display: flex;
  position: relative;
  right: 0px;
  justify-content: end;
  align-items: end;
  text-align: end;
  width: 32px;
}

.select-container {
  padding: 10px;
}

@media screen and (max-width: 640px) {
  #chat-content-wrapper.hide {
    display: none;
  }
  .chat-history-list {
    width: auto;
  }
  .tabs-container.vertical .tab-content.active {
    width: calc(100% - 20px);
  }
}
@media screen and (min-width: 320px) and (max-width: 767px) {
  audio {
    width: 300px !important;
  }
  #expand-collapse {
    visibility: visible;
  }
  .select-container {
    padding: 0px 20px;
    position: absolute;
    right: 20px;
    top: 70px;
    background: #fff;
    /* width: 28%; */
    justify-content: center;
    align-items: center;
    height: 21vh;
    min-width: 148px;
  }
  .dropdown-list {
    margin: 10px;
  }
  .mobile-close-btn {
    display: block;
  }
  .hidemobileView {
    display: none;
  }
  #botWrapper.rightpanel-active #chat-content-wrapper {
    display: none !important;
  }
  #botWrapper.rightpanel-active #right-side-panel {
    width: 100%;
  }
  #botWrapper.leftpanel-active #chat-content-wrapper {
    display: none !important;
  }
  #botinput-wrapper {
    width: 100% !important;
  }
  .chat-header {
    width: 100% !important;
    justify-content: center;
  }
  #chat-list-content {
    padding: 1% 0%;
    width: 100%;
    margin-left: 0%;
  }
  #chat-list {
    width: 100%;
  }
  #chat-content-wrapper header {
    padding: 0px 5px !important;
  }
  #designlist li {
    height: 150px !important;
  }
}
#botinput-wrapper {
  width: 94%;
}
#botinput-wrapper p.disclaimer {
  color: #000000 !important;
  font-size: 14px;
  padding: 0px 10px 0px;
  font-family: sans-serif;
}
#botinput-wrapper p.disclaimer label span {
  display: inline-block;
  text-align: center;
  padding: 10px;
  color: rgb(13, 12, 9);
}
#botinput-wrapper p.disclaimer .expan-down-arrow {
  display: flex;
  justify-content: center;
}
#botinput-wrapper p.disclaimer .expan-down-arrow a {
  background-color: #fff;
  padding: 7px;
}
#botinput-wrapper p.disclaimer .expan-down-arrow a .fa {
  font-size: 1.5rem !important;
}

.bot-middle-content {
  width: 100%;
  max-width: 960px;
  margin: auto;
}

#template-title {
  display: inline-flex;
  width: 100%;
  font-size: 1rem;
}
#template-title span:nth-child(1) {
  width: 80%;
  text-align: center;
}
#template-title span:nth-child(2) {
  width: 20%;
}
#template-title .button {
  border-color: #fff;
  border-width: 0px;
}

#designlist-wrapper {
  height: 90vh;
  overflow-y: auto;
  padding: 0px 20px;
}

@media screen and (max-width: 640px) {
  .chat-history-list {
    left: 0px;
    top: 0px;
  }
}
@media screen and (min-width: 768px) and (max-width: 960px) {
  #chat-list-content {
    padding: 1% 3% 0% 1% !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/summarize/summarize/summarize.component.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;AACJ;;AAEA;EACC,6BAAA;AACD;;AAEA;EACI,YAAA;AACJ;;AAGA;EACI,WAAA;EACA,aAAA;EACA,6BAAA;AAAJ;;AAGA;EACI,aAAA;EACA,YAAA;EACA,mBAAA;EACA,wBAAA;AAAJ;;AAGA;EACE,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,gDAAA;AAAF;;AAIA;EACI,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,YAAA;AADJ;;AAGA;EACI,aAAA;AAAJ;;AAEA;EACI,eAAA;AACJ;;AACA;EACI,kBAAA;EACA,gBAAA;EACA,UAAA;AAEJ;;AAAA;EACG,gBAAA;EACD,gBAAA;EACA,gBAAA;EACA,gDAAA;EACA,gCAAA;AAGF;;AADA;EACI,sBAAA;EACA,oCAAA;EACA,cAAA;EACA,WAAA;EACA,gBAAA;EACA,aAAA;EACA,6BAAA;AAIJ;;AAFA;EACI,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,6BAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AAKJ;;AAHA;EACI,YAAA;EACA,gBAAA;AAMJ;;AAJA;EACI,gBAAA;EACA,iBAAA;EACA,gBAAA;EACD,aAAA;EACA,sBAAA;EACA,mBAAA;AAOH;AANG;EACE,oBAAA;EACD,6BAAA;EACA,qBAAA;AAQJ;AAPO;EACK,qBAAA;EACA,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,UAAA;AASZ;AAPQ;EACI,aAAA;EACA,qBAAA;EACA,SAAA;EACA,gBAAA;AASZ;;AALA;EAEI,YAAA;EACA,UAAA;EACA,cAAA;EACD,4BAAA;AAOH;;AAJA;EACI,kBAAA;EACA,gBAAA;EACA,UAAA;EACA,YAAA;EACA,kBAAA;EACA,wBAAA,EAAA,gBAAA;EACA,qBAAA,EAAA,YAAA;AAOJ;;AAJA;EACE,aAAA;AAOF;;AAJA;EACI,aAAA;EACA,sBAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;AAOJ;;AAFA;EACI,qBAAA;EACA,gBAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,6BAAA;EACA,mBAAA;EACA,kBAAA;EACA,2CAAA;EAEA,UAAA;EACA,cAAA;AAIJ;AAHG;EACK,aAAA;EACA,mBAAA;EACA,6BAAA;EACA,WAAA;AAKR;AAHI;EACI,sBAAA;EACA,YAAA;EACA,aAAA;EACA,WAAA;EACA,cAAA;EACA,YAAA;EACA,YAAA;AAKR;AAHM;EACE,qBAAA;EACA,WAAA;EACA,sBAAA;EACA,aAAA;EACA,WAAA;EACA,cAAA;EACA,gBAAA;AAKR;;AAFA;;;;;;;;GAAA;AAUA;EACI,cAAA;EACA,eAAA;EACA,0BAAA;AAIJ;;AAFA;EACI,uBAAA;AAKJ;;AAHA;EACI,oCAAA;AAMJ;;AAHE;EAGE,2BAAA;EACA,yBAAA;EACA,gBAAA;EAEA,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;EAEA,WAAA;EAEA,kBAAA;EACA,mTAAA;EACA,kCAAA;EACA,uDAAA;EACA,wDAAA;AACJ;;AACA;;;;;;;;;;;;;GAAA;AAcA;EACI,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,WAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;AAEJ;;AAAA;EACI,YAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,YAAA;EACA,QAAA;EACA,YAAA;EACA,kBAAA;EACA,yDAAA;AAGJ;;AACA;EACI,gBAAA;AAEJ;;AAAA;EACI,gBAAA;EACA,gBAAA;EAEA,aAAA;EACA,WAAA;EACD,aAAA;EACC,sBAAA;EACA,WAAA;EAIA,kDAAA;EACA,2QAAA;AADJ;;AAKA;EACI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;AAFJ;AAGI;EACI,iBAAA;AADR;;AAKA;EACI,eAAA;AAFJ;;AAIA;EACI,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,qBAAA;EACA,eAAA;AADJ;;AAGA;EACI,kBAAA;AAAJ;AAEI;EACI,kBAAA;EACA,UAAA;EACA,UAAA;EACA,kBAAA;AAAR;AACQ;EACI,iBAAA;EACA,qBAAA;EACA,eAAA;AACZ;AAEQ;EACI,cAAA;AAAZ;AAII;EACI,cAAA;AAFR;AAKI;EACI,WAAA;EACA,aAAA;EACA,uBAAA;EACA,eAAA;AAHR;;AASA;EACI,sBAAA;AANJ;;AASA;EACI,uBAAA;AANJ;AAOI;EACI,0BAAA;EACA,0BAAA;EACA,WAAA;EACA,iBAAA;AALR;AAQI;EACI,oCAAA;EACA,0BAAA;AANR;;AAUA;;;;;;;;;;;;GAAA;AAcA;EACG,kBAAA;EAEA,iBAAA;EACA,gBAAA;EACA,iBAAA;EACC,WAAA;AATJ;;AAeA;EACI,wBAAA;AAZJ;;AAiBA;EACI,YAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,QAAA;EACA,YAAA;EACA,kBAAA;EACA,sDAAA;AAdJ;;AAiBA;EACG,kBAAA;EAEC,WAAA;AAfJ;AAiBI;EACI,aAAA;AAfR;;AAmBA;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,oCAAA;AAhBJ;AAiBI;EACI,eAAA;AAfR;AAiBI;EACI,mBAAA;AAfR;;AAkBA;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,oCAAA;EACA,0BAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,qBAAA;EACA,yBAAA;AAfJ;;AAmBA;EACI,WAAA;EACA,eAAA;EACA,kBAAA;AAhBJ;;AAoBA;EACI,UAAA;EACA,eAAA;EACA,iBAAA;AAjBJ;;AAqBA;EACI,kBAAA;EACA,gBAAA;EACA,YAAA;AAlBJ;AAmBG;EACC,gBAAA;EACA,aAAA;AAjBJ;AAmBI;EACI,2BAAA;EACA,yCAAA;EACA,yBAAA;AAjBR;;AAsBA;EACI,UAAA;AAnBJ;;AAsBE,UAAA;AACA;EACE,gBAAA;AAnBJ;;AAsBE,WAAA;AACA;EACE,gBAAA;AAnBJ;;AAsBE,oBAAA;AACA;EACE,gBAAA;AAnBJ;;AAsBE;EACE,aAAA;EACA,6BAAA;EACA,WAAA;EACA,sBAAA;AAnBJ;AAqBI;EACI,kCAAA;EACA,uBAAA;AAnBR;;AAsBC;EACG,uBAAA;AAnBJ;AAoBK;EACG,aAAA;AAlBR;AAoBK;EACG,UAAA;EACA,gBAAA;AAlBR;AAsBQ;EACI,uBAAA;AApBZ;AAsBQ;EACI,WAAA;AApBZ;;AA0BC;EACG,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,mBAAA;EACA,YAAA;AAvBJ;AAwBI;EACI,qBAAA;EACA,WAAA;AAtBR;;AAyBA;EACI,aAAA;EACA,qBAAA;EACA,WAAA;EACA,mBAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,WAAA;AAtBJ;AAwBI;EACI,0BAAA;AAtBR;;AAyBA;EACI,wBAAA;AAtBJ;;AAyBE;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,QAAA;EACA,SAAA;EACA,sBAAA;EACA,qCAAA;EACA,+CAAA;EACA,qBAAA;EACA,yBAAA;EACA,8CAAA;AAtBJ;;AAwBA;EAKM,aAAA;EACF,gBAAA;EACA,sBAAA;EAEA,UAAA;AA1BJ;AA4BI;EACI,kCAAA;EAAA,6BAAA;AA1BR;AA4BI;EACI,YAAA;AA1BR;AA4BI;EACI,WAAA;EACA,aAAA;EACA,eAAA;AA1BR;AA2BQ;EACI,yBAAA;EACA,2BAAA;EACA,sBAAA;AAzBZ;AA4BQ;EACI,mCAAA;EACA,4BAAA;EACA,iBAAA;EACA,WAAA;EACA,+BAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,oCAAA;AA1BZ;;AAgCA;EACE,aAAA;EACA,gBAAA;EACA,mBAAA;AA7BF;;AA+BA;EACI,iBAAA;EACA,gBAAA;AA5BJ;AA6BI;EACI,iBAAA;AA3BR;AA6BI;EACI,kBAAA;AA3BR;AA8BI;EACI,gBAAA;AA5BR;AA6BQ;EACI,YAAA;AA3BZ;AAgCQ;EACI,0CAAA;EACA,sBAAA;AA9BZ;;AAkCC;EACO,gBAAA;EACA,MAAA;EACA,mBAAA;AA/BR;;AAmCA;EAEI;IACI,gBAAA;IACA,MAAA;IACA,mBAAA;EAjCN;EAoCE;IACI,UAAA;EAlCN;EAoCG;IACG,yBAAA;EAlCN;EAoCG;IACG,gBAAA;EAlCN;AACF;AAqCA;EACI;IACC,+BAAA;EAnCH;AACF;AAsCA;EACI,aAAA;EACA,WAAA;EACA,kBAAA;EACA,uBAAA;EACA,gBAAA;AApCJ;;AAuCA;EACC,6BAAA;AApCD;;AAsCA;EACI,kCAAA;EACA,0BAAA;EACA,2BAAA;AAnCJ;;AAsCA;EACI,2BAAA;EACA,uBAAA;AAnCJ;;AAqCA;EACI,YAAA;EACD,uBAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACI,cAAA;AAlCP;;AAqCA;EACI,WAAA;EACA,aAAA;EACA,iBAAA;AAlCJ;;AAuCI;EACI,+CAAA;AApCR;AAqCM;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;AAnCR;AAsCM;EACE,mBAAA;AApCR;;AA2CM;EAEE,SAAA;AAzCR;;AA6CA;EACI,UAAA;EACA,6BAAA;AA1CJ;;AA6CA;EACI,aAAA;EACA,YAAA;EACA,mBAAA;EACA,wBAAA;AA1CJ;;AA6CA;EACE,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,gDAAA;AA1CF;;AA8CA;EACI,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,YAAA;AA3CJ;;AA6CA;EACI,aAAA;AA1CJ;;AA4CA;EACI,eAAA;AAzCJ;;AA2CA;EACI,kBAAA;EACA,gBAAA;EACA,UAAA;AAxCJ;;AA0CA;EACG,gBAAA;EACD,gBAAA;EACA,gBAAA;EACA,gDAAA;EACA,gCAAA;AAvCF;;AAyCA;EACI,sBAAA;EACA,oCAAA;EACA,cAAA;EACA,WAAA;EACA,gBAAA;EACA,aAAA;EACA,6BAAA;AAtCJ;;AAwCA;EACI,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,6BAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AArCJ;;AAuCA;EACI,aAAA;EACA,8BAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,UAAA;EACA,UAAA;EACA,QAAA;AApCJ;AAqCI;EACI,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,qBAAA;EACA,oBAAA;AAnCR;AAsCI;EACI,aAAA;AApCR;AAuCI;EACI,kBAAA;EACA,YAAA;EAAa,YAAA;EAAc,8BAAA;AAnCnC;AA2CI;EAEI,cAAA;AA1CR;;AA6CA;EACI,WAAA;EACA,gBAAA;AA1CJ;;AA4CA;EACI,gBAAA;EACA,iBAAA;EACA,gBAAA;EACD,aAAA;EACA,sBAAA;EACA,mBAAA;AAzCH;AA0CG;EACE,oBAAA;EACD,6BAAA;EACA,qBAAA;EACA,sDAAA;EACA,sBAAA;AAxCJ;AA4CO;EACK,qBAAA;EAGA,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,UAAA;AA5CZ;AA8CQ;EACI,aAAA;EACA,qBAAA;EACA,SAAA;EACA,gBAAA;AA5CZ;;AAgDA;EACI,kBAAA;EACC,WAAA;EACD,aAAA;EACA,2BAAA;EACA,gBAAA;EACA,4BAAA;EACA,+BAAA;EACA,gBAAA;EACA,qBAAA;EACA,sBAAA;AA7CJ;;AAgDA;EAEI,WAAA;EACA,qBAAA;EAEA,iBAAA;EAEA,kBAAA;EAEA,wBAAA,EAAA,gBAAA;EACA,qBAAA,EAAA,YAAA;AAjDJ;;AAoDA;EACE,aAAA;AAjDF;;AAoDA;EACI,aAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;AAjDJ;;AAsDA;EAEI,gBAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,6BAAA;EACA,mBAAA;EACA,kBAAA;EACA,2CAAA;EAEA,UAAA;AArDJ;AAuDG;EACK,aAAA;EACA,mBAAA;EACA,6BAAA;EACA,WAAA;AArDR;AAuDI;EACI,sBAAA;EACA,YAAA;EACA,aAAA;EACA,WAAA;EACA,cAAA;EACA,YAAA;EACA,YAAA;AArDR;AAuDM;EACE,qBAAA;EACA,WAAA;EACA,sBAAA;EACA,aAAA;EACA,WAAA;EACA,cAAA;EACA,gBAAA;AArDR;;AAwDA;;;;;;;;GAAA;AAUA;EACI,cAAA;EACA,eAAA;EACA,0BAAA;AAtDJ;;AAwDA;EACI,uBAAA;AArDJ;;AAuDA;EACI,oCAAA;AApDJ;;AAuDE;EACE,mBAAA;EACA,2BAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,WAAA;EACA,mBAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,kCAAA;EACA,uDAAA;EACA,wDAAA;AApDJ;;AAsDA;EACI,YAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,QAAA;EACA,YAAA;EACA,kBAAA;EACA,yDAAA;EACA,gEAAA;EACA,8DAAA;AAnDJ;;AAsDA;EACI,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,WAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;AAnDJ;;AAqDA;EACI,YAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,YAAA;EACA,QAAA;EACA,YAAA;EACA,kBAAA;EACA,yDAAA;AAlDJ;;AAsDA;EACI,gBAAA;AAnDJ;;AAqDA;EACI,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,WAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,iBAAA;EACA,kDAAA;AAlDJ;AAmDI;EACI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,SAAA;AAjDR;AAoDI;EACI,eAAA;AAlDR;AAqDI;EACI,kBAAA;AAnDR;AAqDQ;EACI,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;EACA,UAAA;EACA,UAAA;EACA,kBAAA;EACA;;8BAAA;AAjDZ;AAoDW;EACK,4BAAA;EACA,qBAAA;EACA,eAAA;EACA;;KAAA;AAhDhB;AAqDY;EACI,cAAA;AAnDhB;AAuDQ;EACI,cAAA;AArDZ;AAwDQ;EACI,WAAA;EACA,aAAA;EACA,uBAAA;EACA,eAAA;AAtDZ;;AA6DA;EACI,YAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,kBAAA;EACA,sDAAA;AA1DJ;;AA6DA;EACG,kBAAA;EACA,gBAAA;AA1DH;AA2DI;EACI,aAAA;AAzDR;;AA6DA;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;AA1DJ;AA2DI;EACI,mBAAA;AAzDR;;AA4DA;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,cA3cW;EA4cX,sBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,qBAAA;EACA,yBAAA;AAzDJ;;AA6DA;EACI,WAAA;EACA,eAAA;AA1DJ;;AA8DA;EACI,UAAA;EACA,eAAA;EACA,iBAAA;AA3DJ;;AA+DA;EACI,kBAAA;EACA,gBAAA;EACA,YAAA;AA5DJ;AA6DG;EACC,gBAAA;EACA,YAAA;AA3DJ;AA6DI;EACI,2BAAA;EACA,yCAAA;EACA,yBAAA;AA3DR;;AAgEA;EACI,kBAAA;EAEA,YAAA;AA9DJ;AA+DG;EACC,gBAAA;EACA,YAAA;AA7DJ;AA+DI;EACI,2BAAA;EACA,uCAAA;EACA,yBAAA;AA7DR;;AAkEA;EACI,UAAA;AA/DJ;;AAkEE,UAAA;AACA;EACE,gBAAA;AA/DJ;;AAkEE,WAAA;AACA;EACE,gBAAA;AA/DJ;;AAkEE,oBAAA;AACA;EACE,gBAAA;AA/DJ;;AAuEI;EACI,kCAAA;EACA,uBAAA;AApER;;AAyEC;EACG,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,mBAAA;EACA,YAAA;AAtEJ;AAuEI;EACI,qBAAA;EACA,WAAA;AArER;;AAwEA;EACI,aAAA;EACA,qBAAA;EACA,WAAA;EACA,mBAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,WAAA;EACA,QAAA;EA4DE,oBAAA;AAhIN;AAqEI;EACI,0BAAA;AAnER;AAuEI;EACI,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;AArER;AAsEQ;EACI,gBAAA;AApEZ;AAwEM;EACE,UAAA;EACA,QAAA;EACA,SAAA;AAtER;AAyEM;EACE,kBAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,sBAAA;EAEA,gBAAA;AAvER;AA0EM;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;EACA,WAAA;EACA,uBAAA;EAEA,gBAAA;AAxER;AA2EM;EACE,qCAAA;AAzER;AA4EM;EACE,2BAAA;AA1ER;AA6EM;EAGE,2BAAA;AA3ER;AA+EM;EACE,mBAAA;AA7ER;AAgFM;EACE,kBAAA;AA9ER;;AAkFA;EACI,wBAAA;AA/EJ;;AAkFE;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,QAAA;EACA,SAAA;EACA,sBAAA;EACA,qCAAA;EACA,+CAAA;EACA,qBAAA;EACA,yBAAA;EACA,8CAAA;AA/EJ;;AAiFA;EACI,kBAAA;EACA,YAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,gBAAA;EACA,kBAAA;EACA,2CAAA;EACA,YAAA;AA9EJ;AAkFI;EACI,kCAAA;EAAA,6BAAA;AAhFR;AAkFI;EACI,YAAA;AAhFR;AAkFI;EACI,WAAA;EACA,aAAA;EACA,gBAAA;AAhFR;AAiFQ;EACI,yBAAA;EACA,2BAAA;EACA,sBAAA;AA/EZ;AAkFQ;EACI,mCAAA;EACA,4BAAA;EACA,iBAAA;EACA,WAAA;EACA,mBAlrBG;EAmrBH,kBAAA;EACA,YAAA;EACA,eAAA;EACA,oCAAA;AAhFZ;;AAsFA;EACE,cAAA;AAnFF;;AA0FA;EACI,YAAA;EACA,UAAA;EACA,SAAA;EACA,eAAA;AAvFJ;;AA2FA;EACI,cAAA;EACA,kBAAA;EACA,cAAA;EACA,YAAA;EACA,YAAA;EACA,sBAAA;AAxFJ;;AA2FA;EACI,cAAA;AAxFJ;;AA2FA;EACI,cAAA;EACA,mBAAA;AAxFJ;;AA6FA;EACI,UAAA;EACA,gBAAA;EACA,+BAAA;EACA,aAAA;AA1FJ;;AA4FA;EACI,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,aAAA;AAzFJ;AA0FI;EACI,eAAA;EACA,iBAAA;AAxFR;;AA4FA;EACI,gBAAA;EAEA,YAAA;EACA,mBAAA;EACA,yBAAA;EAEA,cAAA;EACA,eAAA;EACD,WAAA;EACA,aAAA;EACA,gBAAA;AA3FH;AA4FI;EACC,sCAAA;AA1FL;;AA8FA;EACI;IACI,aAAA;IACA,mCAAA;EA3FN;EA6FE;IACI,aAAA;EA3FN;AACF;AA8FA;EACI,aAAA;EACA,kBAAA;EACA,UAAA;EACA,oBAAA;EACA,gBAAA;EACA,eAAA;EACA,WAAA;AA5FJ;;AA+FA;EACI,aAAA;AA5FJ;;AA+FA;EACK;IACG,aAAA;EA5FN;EA8FG;IACG,WAAA;EA5FN;EAoGM;IACC,wBAAA;EAlGP;AACF;AAyGA;EACE;IACE,uBAAA;EAvGF;EAyGC;IACC,mBAAA;EAvGF;EAyGE;IACI,iBAAA;IACA,kBAAA;IACA,WAAA;IACA,SAAA;IACA,gBAAA;IACA,gBAAA;IACA,uBAAA;IACA,mBAAA;IACA,YAAA;IACA,gBAAA;EAvGN;EA0GE;IACI,YAAA;EAxGN;EA0GE;IACI,cAAA;EAxGN;EA2GE;IACI,aAAA;EAzGN;EA8GM;IACI,wBAAA;EA5GV;EA8GM;IACI,WAAA;EA5GV;EAgHM;IACI,wBAAA;EA9GV;EAkHE;IACG,sBAAA;EAhHL;EAmHE;IACI,sBAAA;IACA,uBAAA;EAjHN;EAoHE;IACI,cAAA;IACA,WAAA;IACA,eAAA;EAlHN;EAoHE;IACI,WAAA;EAlHN;EAsHM;IACI,2BAAA;EApHV;EAwHE;IACI,wBAAA;EAtHN;AACF;AA2HA;EACI,UAAA;AAzHJ;AA0HI;EACG,yBAAA;EACA,eAAA;EACC,qBAAA;EACD,uBAAA;AAxHP;AAyHO;EACC,qBAAA;EAEA,kBAAA;EACA,aAAA;EACA,qBAAA;AAxHR;AA2HO;EACC,aAAA;EACA,uBAAA;AAzHR;AA0HQ;EACE,sBAAA;EACA,YAAA;AAxHV;AAyHU;EACE,4BAAA;AAvHZ;;AA8HA;EACI,WAAA;EACA,gBAAA;EACA,YAAA;AA3HJ;;AA8HA;EACI,oBAAA;EACA,WAAA;EACA,eAAA;AA3HJ;AA6HI;EACI,UAAA;EACA,kBAAA;AA3HR;AA6HI;EACI,UAAA;AA3HR;AA6HI;EACI,kBAAA;EACA,iBAAA;AA3HR;;AA+HA;EACI,YAAA;EACA,gBAAA;EACA,iBAAA;AA5HJ;;AA+HA;EACI;IACE,SAAA;IACA,QAAA;EA5HJ;AACF;AA+HA;EACI;IACC,+BAAA;EA7HH;AACF","sourcesContent":[":host{\n    width:100%;\n}\n\nbody::ng-deep{\n overflow-y: hidden !important;\n}\n\n.chat-header{\n    height:50px;\n\n}\n\n.chat-header,.chat-content{\n    width:100%;\n    display: flex;\n    justify-content: space-evenly;\n}\n\n.wrapper {\n    display:flex;\n    height:100%;\n    flex-direction:row;\n    justify-content:stretch;\n}\n\n.chat-sidebar{\n  max-width:320px;\n  height:100%;\n  background: #fff;\n  box-shadow: rgba(0, 0, 0, 0.15) 1.95px 0px 2.6px;\n}\n\n\n.chatBotstyle{\n    display: flex;\n    flex-direction: row;\n    width:100% !important;\n    height:100%;\n}\n.hide{\n    display: none;\n}\n.fa{\n    cursor: pointer;\n}\n.chat-box-wrapper{\n    position: relative;\n    display:flexbox;\n    width:90%;\n}\n.chat-left-content{\n   background:#fff;\n  min-width:280px;\n  overflow-y: auto;\n  /* box-shadow:2px 0px 0px rgba(0, 0, 0, 0.21); */\n  /* box-shadow:3px 0px #e9e9e9; */\n}\n.chat-right-content{\n    /* margin-left:20px; */\n    /* width: clamp(300px,150vw,70vw); */\n    min-width:70%;\n    width:100%;\n    overflow-y: auto;\n    display: flex;\n    justify-content:space-evenly;\n}\n#title{\n    display: flex;\n    flex-direction: row;\n    align-items: baseline;\n    justify-content: space-evenly;\n    margin:10px 0px;\n    font-size: 16px;\n    font-weight:bold;\n}\n.chat-history-list{\n    height:80vh;\n    overflow-y: auto;\n}\n.chat-history-list ul{\n    margin:10px 0px;\n    padding:0px 10px;\n    list-style: none;\n   display: flex;\n   flex-direction: column;\n   line-height:1.2rem;\n   & li{\n     display: inline-flex;\n    justify-content: space-evenly;\n    align-items: baseline;\n       & label:first-child {\n            display: inline-block;\n            background:#eee;\n            color:#666;\n            border-radius:10px;\n            white-space: nowrap;\n            overflow: hidden;\n            text-overflow: ellipsis;\n            cursor: pointer;\n            font-size: .9rem;\n            min-height: 25px;\n            padding:10px 10px;\n            margin-bottom:10px;\n            width:90%;\n        }\n        & label:last-child {\n            margin:0% 3%;\n            display: inline-block;\n            width:5%;\n            padding-left:2%;\n        }\n    }\n}\n#chat-list-content{\n   \n    margin:auto;\n    width:60%;\n    padding: 0% 2%;\n   font-size:.9rem !important;\n \n}\n#chat-list{\n    position: relative;\n    overflow-y: auto;\n    width:95%;\n    height:80vh;\n    padding-right:5px;\n    -ms-overflow-style: none;  /* IE and Edge */\n    scrollbar-width: none;  /* Firefox */\n\n}\n#chat-list::-webkit-scrollbar {\n  display: none;\n}\n\n.chat-list-row{\n    display: flex;\n    flex-direction: column;\n    width:100%;\n    position: relative;\n    padding:0px 0px;\n}\n\n\n\n#chat-message-enter-box{\n    /* position: fixed; */\n    background: #fff;\n    width:60%;\n    display: flex;\n    flex-direction: row;\n    justify-content: space-evenly;\n    align-items: center;\n    border-radius:5px;\n    box-shadow: rgba(0, 0, 0, 0.35) 0px 1px 5px;\n \n    z-index:1;\n    /* top:65px; */\n   & form{\n        display: flex;\n        align-items: center;\n        justify-content: space-evenly;\n        width: 100%;\n    }\n    & textarea{\n        width:100% !important;\n        border: none;\n        padding: 10px;\n        color: #666;\n        font-size:1em;\n        resize: none;\n        height:55px;\n      }\n      & span{\n        display: inline-block;\n        color: #666;\n        width:100% !important;\n        padding: 10px;\n        color: #666;\n        font-size:1em;\n        min-height:55px;\n      }\n}\n/* .chat-header > span{\n    display: inline-block;\n        color: #666;\n        width: 90% !important;\n        padding: 10px;\n        color: #666;\n        font-size:1em;\n        min-height:100px;\n} */\n\n.fa-cloud,.fa-user-circle{\n    color: #9da0a3;\n    margin-top:5px;\n    font-size:30px !important;\n}\napp-toggle-icon::ng-deep .fa-microphone-slash,.fa-microphone-slash{\n    opacity:0.5 !important;\n}\ntextarea::placeholder {\n    color: rgb(182, 182, 182) !important;\n  }\n\n  .question{\n   // background:#6089ca;\n //  background:var(--primaryColor);\n    /* background: #9da0a3;   */\n    /* background: #01488f; */\n    min-height:50px;\n   // border-radius:5px;\n    padding:15px 10px;\n    background: #fff;\n    color: #000;\n    font-weight: bold;\n    margin-bottom:2px;\n    //margin-bottom:10px;\n    width:100%;\n   // margin-left:15px;\n    position: relative;\n    box-shadow: rgba(14, 63, 126, 0.06) 0px 0px 0px 1px, rgba(42, 51, 70, 0.03) 0px 1px 1px -0.5px, rgba(42, 51, 70, 0.04) 0px 2px 2px -1px, rgba(42, 51, 70, 0.04) 0px 3px 3px -1.5px, rgba(42, 51, 70, 0.03) 0px 5px 5px -2.5px, rgba(42, 51, 70, 0.03) 0px 10px 10px -5px, rgba(42, 51, 70, 0.03) 0px 24px 24px -8px;\n    /* box-shadow: 2px 2px 3px #000; */\n    /* box-shadow: rgba(25, 118, 210, 0.35) 0px 5px 15px; */\n    /* box-shadow: rgba(109, 129, 153, 0.35) 0px 5px 15px; */\n}\n/* .question::before{\n    content: \" \";\n    position: absolute;\n    width: 0;\n    height: 0;\n    left:-15px;\n    right:auto;\n    top:10px;\n    bottom: auto;\n    border:15px solid;\n    border-color:var(--primaryColor) transparent transparent transparent;\n\n\n} */\n.question.align-right{\n    /* background: #f2fcff; */\n    background: #9da0a3;\n    min-height:50px;\n    border-radius:5px;\n    padding:10px;\n    color: #fff;\n    margin-bottom:10px;\n    width:100%;\n    margin-left:50%;\n    margin-right:15px;\n    position: relative;\n}\n.question.align-right::before{\n    content: \" \";\n    position: absolute;\n    width: 0;\n    height: 0;\n    left: auto;\n    right:-20px;\n    top:0px;\n    bottom: auto;\n    border: 21px solid;\n    border-color: #848a92 transparent transparent transparent;\n\n}\n\nvideo{\n    margin:10px 0px;\n}\n.answer{\n    background: #fff;\n    min-height:50px;\n   // border-radius:5px;\n    padding:10px;\n    color: #666;\n   display: flex;\n    flex-direction: column;\n    width: 100%;\n   // margin-left:19px;\n   // box-shadow: 1px 0px 3px #5555556e;\n//    border: 1px solid #c8c8c8;\n    /* box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px; */\n    box-shadow: rgba(14, 63, 126, 0.04) 0px 0px 0px 1px, rgba(42, 51, 69, 0.04) 0px 1px 1px -0.5px, rgba(42, 51, 70, 0.04) 0px 3px 3px -1.5px, rgba(42, 51, 70, 0.04) 0px 6px 6px -3px, rgba(14, 63, 126, 0.04) 0px 12px 12px -6px, rgba(14, 63, 126, 0.04) 0px 24px 24px -12px;\n   \n}\n\n.answer-header{\n    display: flex;\n    flex-direction: row;\n    justify-content:flex-end;\n    padding-right:10px;\n    gap: 15px;\n    min-height:30px;\n    padding-top:5px;\n    background: #fff;\n    span{\n        font-weight:bold;\n    }\n}\n\n.audio{\n    cursor: pointer;\n}\nul li{\n    display: inline;\n    list-style: none;\n    margin: 5px 10px;\n    display:inline-block;\n    cursor: pointer;\n}\n.menu-list{\n    position: relative;\n\n    & ul{\n        position: absolute;\n        top:-10px;\n        right:0px;\n        width:max-content;\n        li{\n            margin:10px 10px;\n            display:inline-block;\n            cursor: pointer;\n       }\n        li:hover{\n        .fa{\n            color: #008cb3;\n           }\n       }\n    }\n    & ul.active{\n        display: block;\n    }\n\n    & label{\n        width:20px;\n        display:flex;\n        justify-content: center;\n        cursor: pointer;\n    }\n\n\n}\n\n.dropdown-menu{\n    left:-55px !important;\n    // top:-100px !important;\n}\n.dropdown-item { \n    padding:0px !important;\n    li{\n        margin:5px 0px !important;\n        font-size:12px !important;\n        width:100%;\n        padding:5px 10px;\n    }\n\n    li:hover{\n        background: var(--primarylightColor);\n        color:var(--primaryColor);\n    }\n}\n\n/*.answer-content::before{\n    content: \" \";\n    position: absolute;\n    width: 0;\n    height: 0;\n    left:-25px;\n    right:auto;\n    top:-25px;\n    bottom: auto;\n    border: 21px solid;\n    border-color: #fff transparent transparent transparent;\n  \n} */\n\n.answer-content{\n   position: relative;\n  // margin-top:25px;\n   padding:10px 5px;\n   line-height:1.6;\n   font-size:.9rem;\n    color: #111;\n   \n    // font-family: sans-serif;\n    \n}\n\n.answer-content::ng-deep ol{\n    padding:10px !important;\n}\n\n\n\n.feedback::before{\n    content: \" \";\n    position: absolute;\n    width: 0;\n    height: 0;\n    left:-25px;\n    right:auto;\n    top:0px;\n    bottom: auto;\n    border: 21px solid;\n    border-color: #fff transparent transparent transparent;\n}\n\n.feedback{\n   position: relative;\n   \n    color: #111;\n    // font-family: sans-serif;\n    & ol{\n        padding:30px;\n    }\n}\n\n.chat-icon{\n    width:35px;\n    height:35px;\n    border-radius: 100%;\n    background:var(--primarylightColor);\n    .bot-icon{\n        margin-top: 5px;\n    }\n    img{\n        border-radius:100%;\n    }\n}\n.username{\n    width: 36px;\n    height: 36px;\n    border-radius: 100%;\n    background:var(--primarylightColor);\n    color: var(--primaryColor);\n    vertical-align: middle;\n    text-align: center;\n    font-size: 22px;\n    margin-right: 5px;\n    display: inline-block;\n    text-transform: uppercase;\n\n}\n\n#chatForm{\n    width:100%;\n    height:inherit;\n    padding:10px 10px;\n\n}\n\n#chatForm > span{\n    width:90%;\n    height:inherit;\n    margin-left:10px;\n\n}\n\n#expand-collapse{\n    position: relative;\n    margin-top:25px;\n    height:15px;\n   i {\n    background: #fff;\n    padding: 10px;\n   }\n    .fa{\n        font-size:1.5em !important;\n        transform: rotate(180deg) translateX(0px);\n        transform-origin: 50% 20%;\n    }\n\n}\n\n::-webkit-scrollbar {\n    width:3px;\n  }\n\n  /* Track */\n  ::-webkit-scrollbar-track {\n    background: #fff;\n  }\n\n  /* Handle */\n  ::-webkit-scrollbar-thumb {\n    background: #fff;\n  }\n\n  /* Handle on hover */\n  ::-webkit-scrollbar-thumb:hover {\n    background: #fff;\n  }\n\n  #chat-content-wrapper{\n    display: flex;\n    justify-content:space-around;\n    width:100%;\n    flex-direction: column;\n\n    header{\n        background: transparent !important;\n        padding:5px !important;\n    }\n }\n .chat-history-list::ng-deep .tabs-container{\n    height:80vh !important;\n     ul{\n        display: flex;\n     }\n     li{\n        width:50%;\n        font-size:.9em;\n     }\n\n     app-tab{\n        .pane{\n            padding:0px !important;\n        }\n        li{\n            width:100%;\n        }\n     }\n }\n\n\n #voice-message{\n    width:80% !important;\n    position: relative;\n    background: #fff;\n    margin-top:-50px;\n    margin-left:10px;\n    padding-right:10px;\n    height: 50px;\n    span{\n        display: inline-block;\n        color:#999;\n    }\n }\n#chat-tools{\n    display: flex;\n    list-style-type: none;\n    width:60px;\n    flex-direction: row;\n    gap:20px;\n    padding: 0px;\n    margin: 0px;\n    position:relative;\n    right:10px;\n\n    .fa-paper-plane{\n        font-size: 17px !important;\n    }\n}\n[hidden] {\n    display: none !important;\n  }\n\n  .comment-area-box::after{\n    content: \"\";\n    position: absolute;\n    width: 0;\n    height: 0;\n    top: 1px;\n    left: 99%;\n    box-sizing: border-box;\n    border: 10px solid rgba(0, 0, 0, 0.5);\n    border-color: transparent transparent #fff #fff;\n    transform-origin: 0 0;\n    transform: rotate(135deg);\n    box-shadow: -1px 1px 1px 0 rgba(0, 0, 0, 0.35);\n  }\n.comment-area-box{\n    // position: absolute;\n    // z-index: 999;\n    // top:40px;\n    // right:0px;\n      display: none;\n    background: #fff;\n    padding:15px 10px 5px;\n    // box-shadow: rgba(0, 0, 0, 0.35) 0px 1px 5px;\n    width:80%;\n\n    label{\n        width: fit-content !important;\n    }\n    textarea{\n        resize: none;\n    }\n    .form-btns{\n        width:100%;\n        display: flex;\n        margin:5px 0px;\n        .btn:first-child{\n            border:1px solid #dbdbdb;\n            background:#fff !important;\n            color:#000 !important;\n          }\n\n        .btn{\n            --bs-btn-line-height:1.2 !important;\n            font-size:.9rem !important;\n            padding:5px 20px;\n            color:#fff;\n            background: var(--primaryColor);\n            margin-right:15px;\n            border: none;\n            cursor: pointer;\n            font-family:\"Noto Sans\", sans-serif;\n          }\n    }\n\n\n}\n.comment-area-box.is-active{\n  display: flex;\n  margin-top:10px;\n  align-items: center;\n}\n.comment-form{\n    margin-left:10px;\n    margin-top:10px;\n    label{\n        font-size:.9rem;\n    }\n    textarea{\n        margin-right:25px;\n    }\n\n    .comments-field{\n        margin-top: 10px;\n        .form-btns{\n            float: right;\n        }\n    }\n\n    .button{\n        &:hover{\n            background: var(--primaryColor)!important;\n            color:#fff!important;\n        }\n    }\n}\n .chat-icon:has(> .bot-icon){\n        position:sticky;\n        top:0;\n        margin-bottom:40px;\n}\n   \n\n@media screen and (max-width:640px){\n   \n    .chat-icon:has(> .bot-icon){\n        position:sticky;\n        top:0;\n        margin-bottom:40px;\n    }\n\n    .chat-list-row{\n        width:98%;\n    }\n     .answer-header{\n        justify-content: flex-end;\n    }\n     .menu-list{\n        margin-top:10px;\n    }\n}\n\n@media screen and (min-width:768px) and (max-width:960px) {\n    #chat-list-content{\n     padding: 1% 3% 0% 1% !important;\n    }\n    \n}\n#botWrapper{\n    display: flex;\n    width: 100%;\n    position: relative;\n    justify-content: center;\n    padding:0px 5px;\n}\n$primary-color:#133aa5;\nbody::ng-deep{\n overflow-y: hidden !important;\n}\n.second-level-menu{\n    background: transparent !important;\n    min-width: auto !important;\n    max-width:350px !important;\n}\n\nheader{\n    border-left:0px !important;\n    height:auto !important;\n}\n.chat-header{\n    height:auto;\n   justify-content: center;\n   margin-top:10px;\n   position: relative;\n   display:flex;\n       padding: 0% 1%;\n}\n\n.chat-header,.chat-content{\n    width:100%;\n    display: flex;\n    margin:10px auto;\n\n}\n\n#botinput-wrapper,#chat-list-content{\n    ul.dropdown-menu{\n        box-shadow: rgba(0, 0, 0, 0.05) 0px 0px 0px 1px;\n      li{\n        display: flex;\n        align-items: center;\n        padding-left:10px;\n        color:#666;\n        height:30px;\n        cursor: pointer;\n      \n      }\n      & li:hover{\n        background:#f1f1f1;\n      }\n    }\n}\n#chat-list-content{\n    ul.dropdown-menu{\n       \n      li{\n       \n        gap:10px;\n      }\n    }\n}\n.chat-content{\n    width:90%;\n    justify-content: space-evenly;\n}\n\n.wrapper {\n    display:flex;\n    height:100%;\n    flex-direction:row;\n    justify-content:stretch;\n}\n\n.chat-sidebar{\n  max-width:320px;\n  height:100%;\n  background: #fff;\n  box-shadow: rgba(0, 0, 0, 0.15) 1.95px 0px 2.6px;\n}\n\n\n.chatBotstyle{\n    display: flex;\n    flex-direction: row;\n    width:100% !important;\n    height:100%;\n}\n.hide{\n    display: none;\n}\n.fa{\n    cursor: pointer;\n}\n.chat-box-wrapper{\n    position: relative;\n    display:flexbox;\n    width:90%;\n}\n.chat-left-content{\n   background:#fff;\n  min-width:280px;\n  overflow-y: auto;\n  /* box-shadow:2px 0px 0px rgba(0, 0, 0, 0.21); */\n  /* box-shadow:3px 0px #e9e9e9; */\n}\n.chat-right-content{\n    /* margin-left:20px; */\n    /* width: clamp(300px,150vw,70vw); */\n    min-width:70%;\n    width:100%;\n    overflow-y: auto;\n    display: flex;\n    justify-content:space-evenly;\n}\n#title{\n    display: flex;\n    flex-direction: row;\n    align-items: baseline;\n    justify-content: space-evenly;\n    margin:10px 0px;\n    font-size: 16px;\n    font-weight:bold;\n}\n.chat-history-list{\n    height:100vh;\n    background:rgba(0,0,0,.1);\n    width:100%;\n    margin-left:0px;\n    position: absolute;\n    z-index:9;\n    right:0px;\n    top:0px;\n    .listing-data{\n        height:90vh;\n        overflow-y: auto;\n        background: #fff;\n        padding-bottom:1.5em;\n        padding-left:.5rem;\n        // width: 295px;\n    }\n    .listing-data.templatesection{\n        height:100vh;\n    }\n\n    .audio-wrapper{\n        position: absolute; \n        z-index:999; right: -2rem; background: rgba(0,0,0,0.5);\n    // display: none;\n        \n        // audio{\n        //     width:300px !important;\n        // }\n        \n    }\n    .audio-wrapper.is-active{\n        \n        display: block;\n    }\n}\n::ng-deep .audio-file-class{\n    width: 100%;\n    min-width: 300px;\n}\n.chat-history-list ul{\n    margin:10px 0px;\n    padding:0px 10px;\n    list-style: none;\n   display: flex;\n   flex-direction: column;\n   line-height:1.2rem;\n   & li{\n     display: inline-flex;\n    justify-content: space-evenly;\n    align-items: baseline;\n    border-bottom:1px solid var(--bodyBgColor) !important;\n    color:#000 !important;\n       & label.odd{\n       // background:var(--bodyBgColor) !important;\n       }\n       & label:first-child {\n            display: inline-block;\n           // background: var(--menuSelectColor);\n            //color: var(--primaryColor);\n            border-radius:10px;\n            white-space: nowrap;\n            overflow: hidden;\n            text-overflow: ellipsis;\n            cursor: pointer;\n            font-size: .9rem;\n            min-height: 25px;\n            padding:10px 10px;\n            margin-bottom:10px;\n            width:90%;\n        }\n        & label:last-child {\n            margin:0% 3%;\n            display: inline-block;\n            width:5%;\n            padding-left:2%;\n        }\n    }\n}\n#chat-list-content{\n    position: relative;\n     width:100%;\n    display: flex;\n    justify-content: flex-start;\n    max-width:960px;\n    font-size:.9rem !important;\n    max-height:calc(100vh - 280px);\n    overflow-y: auto;\n    scrollbar-width: none;  \n    flex-direction: column;\n}\n \n#chat-list{\n \n    width:100%;\n    display:inline-block;\n \n    margin-left:0rem;\n   \n    padding-bottom:5%;\n   \n    -ms-overflow-style: none;  /* IE and Edge */\n    scrollbar-width: none;  /* Firefox */\n\n}\n#chat-list::-webkit-scrollbar {\n  display: none;\n}\n\n.chat-list-row{\n    display: flex;\n    flex-direction: row;\n    width:100%;\n    max-width:960px;\n}\n\n\n\n#chat-message-enter-box{\n    \n    background: #fff;\n    width:100%;\n    display: flex;\n    flex-direction: row;\n    justify-content: space-evenly;\n    align-items: center;\n    border-radius:5px;\n    box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px;\n\n    z-index:1;\n\n   & form{\n        display: flex;\n        align-items: center;\n        justify-content: space-evenly;\n        width: 100%;\n    }\n    & textarea{\n        width:100% !important;\n        border: none;\n        padding: 10px;\n        color: #666;\n        font-size:1em;\n        resize: none;\n        height:55px;\n      }\n      & span{\n        display: inline-block;\n        color: #666;\n        width:100% !important;\n        padding: 10px;\n        color: #666;\n        font-size:1em;\n        min-height:40px;\n      }\n}\n/* .chat-header > span{\n    display: inline-block;\n        color: #666;\n        width: 90% !important;\n        padding: 10px;\n        color: #666;\n        font-size:1em;\n        min-height:100px;\n} */\n\n.fa-cloud,.fa-user-circle{\n    color: #9da0a3;\n    margin-top:5px;\n    font-size:30px !important;\n}\napp-toggle-icon::ng-deep .fa-microphone-slash,.fa-microphone-slash{\n    opacity:0.5 !important;\n}\ntextarea::placeholder {\n    color: rgb(182, 182, 182) !important;\n  }\n\n  .question{\n    background:#848a92;\n    /* background: #9da0a3;   */\n    /* background: #01488f; */\n    min-height:50px;\n    border-radius:5px;\n    padding:10px;\n    color: #fff;\n    margin-bottom:10px;\n    width:100%;\n    margin-left:20px;\n    position: relative;\n    /* box-shadow: 2px 2px 3px #000; */\n    /* box-shadow: rgba(25, 118, 210, 0.35) 0px 5px 15px; */\n    /* box-shadow: rgba(109, 129, 153, 0.35) 0px 5px 15px; */\n}\n.question::before{\n    content: \" \";\n    position: absolute;\n    width: 0;\n    height: 0;\n    left:-20px;\n    right:auto;\n    top:0px;\n    bottom: auto;\n    border: 21px solid;\n    border-color:#848a92 transparent transparent transparent;\n    /* border-color: #9da0a3 transparent transparent transparent;  */\n    /* border-color:#01488f transparent transparent transparent; */\n\n}\n.question.align-right{\n    /* background: #f2fcff; */\n    background: #9da0a3;\n    min-height:50px;\n    border-radius:5px;\n    padding:10px;\n    color: #fff;\n    margin-bottom:10px;\n    width:100%;\n    margin-left:50%;\n    margin-right:15px;\n    position: relative;\n}\n.question.align-right::before{\n    content: \" \";\n    position: absolute;\n    width: 0;\n    height: 0;\n    left: auto;\n    right:-20px;\n    top:0px;\n    bottom: auto;\n    border: 21px solid;\n    border-color: #848a92 transparent transparent transparent;\n\n}\n\nvideo{\n    margin:10px 0px;\n}\n.answer{\n    background: #fff;\n    min-height:50px;\n    border-radius:5px;\n    padding:10px;\n    color: #666;\n    margin-bottom:30px;\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    margin-left:19px;\n    /* box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px; */\n    .answer-header{\n        display: flex;\n        flex-direction: row;\n        justify-content: flex-end;\n        padding-right:10px;\n        gap: 15px;\n    }\n\n    .audio{\n        cursor: pointer;\n    }\n\n    .menu-list{\n        position: relative;\n\n        & ul{\n            position: absolute;\n            /* background: #f5fdff; */\n            /* padding: 10px; */\n            /* z-index: 9999; */\n            top:-10px;\n            right:0px;\n            width:max-content;\n            /* box-shadow: 3px 3px #008cb3;\n            border-radius:5px;\n            border: 1px solid #95bdc7; */\n           & li{\n                margin:10px 10px !important;\n                display:inline-block;\n                cursor: pointer;\n                /* .fa{\n                 color: #008cb3;\n                } */\n            }\n           & li:hover{\n            .fa{\n                color: #008cb3;\n               }\n           }\n        }\n        & ul.active{\n            display: block;\n        }\n\n        & label{\n            width:20px;\n            display:flex;\n            justify-content: center;\n            cursor: pointer;\n        }\n\n\n    }\n}\n\n.answer-content::before{\n    content: \" \";\n    position: absolute;\n    width: 0;\n    height: 0;\n    left: -32px;\n    right:auto;\n    top:-35px;\n    bottom: auto;\n    border: 21px solid;\n    border-color: #fff transparent transparent transparent;\n}\n\n.answer-content{\n   position: relative;\n   margin-top:25px;\n    & ol{\n        padding:30px;\n    }\n}\n\n.chat-icon{\n    width:32px;\n    height:32px;\n    border-radius: 100%;\n    background: #d2daf3;\n    img{\n        border-radius:100%;\n    }\n}\n.username{\n    width: 36px;\n    height: 36px;\n    border-radius: 100%;\n    background: #d2daf3;\n    color: $primary-color;\n    vertical-align: middle;\n    text-align: center;\n    font-size: 22px;\n    margin-right: 5px;\n    display: inline-block;\n    text-transform: uppercase;\n\n}\n\n#chatForm{\n    width:100%;\n    height:inherit;\n\n}\n\n#chatForm > span{\n    width:90%;\n    height:inherit;\n    margin-left:10px;\n\n}\n\n#expand-collapse{\n    position: relative;\n    margin-top:25px;\n    height:15px;\n   i {\n    background: #fff;\n    padding:7px;\n   }\n    .fa{\n        font-size:1.5em !important;\n        transform: rotate(180deg) translateX(0px);\n        transform-origin: 50% 20%;\n    }\n\n}\n\n#expand-collapse-right{\n    position: relative;\n    \n    height:15px;\n   i {\n    background: #fff;\n    padding:7px;\n   }\n    .fa{\n        font-size:1.5em !important;\n        transform: rotate(0deg) translateX(0px);\n        transform-origin: 50% 20%;\n    }\n\n}\n\n::-webkit-scrollbar {\n    width:3px;\n  }\n\n  /* Track */\n  ::-webkit-scrollbar-track {\n    background: #fff;\n  }\n\n  /* Handle */\n  ::-webkit-scrollbar-thumb {\n    background: #fff;\n  }\n\n  /* Handle on hover */\n  ::-webkit-scrollbar-thumb:hover {\n    background: #fff;\n  }\n\n  #chat-content-wrapper{\n   // display: flex;\n    // justify-content:space-between;\n    // width:100%;\n\n    header{\n        background: transparent !important;\n        padding:5px !important;\n    }\n }\n \n\n #voice-message{\n    width:80% !important;\n    position: relative;\n    background: #fff;\n    margin-top:-40px;\n    margin-left:10px;\n    padding-right:10px;\n    height:40px;\n    span{\n        display: inline-block;\n        color:#999;\n    }\n }\n#chat-tools{\n    display: flex;\n    list-style-type: none;\n    width:auto;\n    flex-direction: row;\n    gap:20px;\n    padding: 0px;\n    margin: 0px;\n    position:relative;\n    right:10px;\n    top:5px;\n    .fa-paper-plane{\n        font-size: 17px !important;\n    }\n\n\n    .switch {\n        position: relative;\n        display: inline-block;\n        width:35px;\n        height:20px;\n        span{\n            min-height:20px;\n        }\n      }\n      \n      .switch input { \n        opacity: 0;\n        width: 0;\n        height: 0;\n      }\n      \n      .slider {\n        position: absolute;\n        cursor: pointer;\n        top: 0;\n        left: 0;\n        right: 0;\n        bottom: 0;\n        background-color: #ccc;\n        -webkit-transition: .4s;\n        transition: .4s;\n      }\n      \n      .slider:before {\n        position: absolute;\n        content: \"\";\n        height:15px;\n        width:15px;\n        left: 4px;\n        bottom:3px;\n        background-color: white;\n        -webkit-transition: .4s;\n        transition: .4s;\n      }\n      \n      input:checked + .slider {\n        background-color:var(--primaryColor);\n      }\n      \n      input:focus + .slider {\n        box-shadow: 0 0 1px #2196F3;\n      }\n      \n      input:checked + .slider:before {\n        -webkit-transform: translateX(13px);\n        -ms-transform: translateX(13px);\n        transform: translateX(13px);\n      }\n      \n      /* Rounded sliders */\n      .slider.round {\n        border-radius: 34px;\n      }\n      \n      .slider.round:before {\n        border-radius: 50%;\n      }\n\n}\n[hidden] {\n    display: none !important;\n  }\n\n  .comment-area-box::after{\n    content: \"\";\n    position: absolute;\n    width: 0;\n    height: 0;\n    top: 1px;\n    left: 99%;\n    box-sizing: border-box;\n    border: 10px solid rgba(0, 0, 0, 0.5);\n    border-color: transparent transparent #fff #fff;\n    transform-origin: 0 0;\n    transform: rotate(135deg);\n    box-shadow: -1px 1px 1px 0 rgba(0, 0, 0, 0.35);\n  }\n.comment-area-box{\n    position: absolute;\n    z-index: 999;\n    top:40px;\n    right:0px;\n    display: none;\n    background: #fff;\n    padding: 20px 40px;\n    box-shadow: rgba(0, 0, 0, 0.35) 0px 1px 5px;\n    width:300px;\n\n\n\n    label{\n        width: fit-content !important;\n    }\n    textarea{\n        resize: none;\n    }\n    .form-btns{\n        width:100%;\n        display: flex;\n        margin:10px 0px;\n        .btn:first-child{\n            border:1px solid #dbdbdb;\n            background:#fff !important;\n            color:#000 !important;\n          }\n\n        .btn{\n            --bs-btn-line-height:1.2 !important;\n            font-size:.9rem !important;\n            padding:5px 20px;\n            color:#fff;\n            background: $primary-color;\n            margin-right:15px;\n            border: none;\n            cursor: pointer;\n            font-family:\"Noto Sans\", sans-serif;\n          }\n    }\n\n\n}\n.comment-area-box.is-active{\n  display: block;\n}\n// #langselect{\n//     margin-top:5px;\n//     margin-left:10px;\n// }\n\n.select:not(.is-multiple):not(.is-loading)::after {\n    right:1.5em;\n    z-index: 4;\n    top: 15px;\n    font-size: 12px;\n}\n\n\n.dropdown-list {\n    display: block;\n    border-radius: 5px;\n    display: block;\n    height: 30px;\n    padding: 5px;\n    border: 1px solid gray;\n}\n\n.dropdown-list.show {\n    display: block;\n}\n\n.toggle-button {\n    display: block;\n    margin-bottom: 10px;\n}\n#expand-collapse{\n   // visibility: hidden;\n}\n#right-side-panel{\n    width:20%;\n    background:#fff;\n    box-shadow:0px 0px 4px #b2b2b2;\n    padding:10px;\n}\n#designlist{\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n    padding:10px;\n    label{\n        font-size:14px;\n        font-weight: bold;\n    }\n}\n\n#designlist li{\n    list-style: none;\n   \n    margin:10px;\n    white-space:nowrap;\n    border:1px solid #dcd8d8;\n \n    color: #222222;\n    cursor: pointer;\n   width: 100%;\n   height:100px;\n   overflow: hidden;\n    &.active{\n     border:2px dashed var(--primaryColor);\n    }\n}\n\n@media screen and (min-width: 768px) {\n    .toggle-button {\n        display: none;\n        /* Hide button for larger screens */\n    }\n    .mobile-close-btn{\n        display: none;\n    }\n} \n\n.dropdown-trigger {\n    display: flex;\n    position: relative;\n    right: 0px;\n    justify-content: end;\n    align-items: end;\n    text-align: end;\n    width: 32px;\n}\n\n.select-container {\n    padding: 10px;\n}\n\n@media screen and (max-width:640px) {\n     #chat-content-wrapper.hide{\n        display: none;\n     }\n     .chat-history-list{\n        width:auto;\n        \n     }\n    //  .chat-history-list::ng-deep .tabs-container.vertical{\n    //     width:85% !important;\n    // }\n\n    .tabs-container.vertical  {\n        .tab-content.active {\n         width: calc(100% - 20px);\n        }\n    }\n    #chat-list{\n       // height:80vh;\n    }\n}\n\n@media screen and (min-width: 320px) and (max-width: 767px) {\n  audio{\n    width:300px !important;\n  }\n   #expand-collapse{\n    visibility:visible;\n   }\n    .select-container {\n        padding: 0px 20px;\n        position: absolute;\n        right: 20px;\n        top: 70px;\n        background: #fff;\n        /* width: 28%; */\n        justify-content: center;\n        align-items: center;\n        height: 21vh;\n        min-width: 148px;\n    }\n\n    .dropdown-list{\n        margin: 10px;\n    }\n    .mobile-close-btn{\n        display: block;\n    }\n\n    .hidemobileView{\n        display: none;\n    }\n\n     \n    #botWrapper.rightpanel-active{\n        #chat-content-wrapper{\n            display: none !important;\n        }\n        #right-side-panel{\n            width:100%;\n        }\n    }\n    #botWrapper.leftpanel-active{\n        #chat-content-wrapper{\n            display: none !important;\n        }\n    }\n\n    #botinput-wrapper{\n       width:100% !important;\n    \n    }\n    .chat-header{\n        width:100% !important;\n        justify-content:center;\n    }\n\n    #chat-list-content{\n        padding:1% 0%;\n        width:100%;\n        margin-left:0%;\n    }\n    #chat-list{\n        width:100%;\n    }\n\n    #chat-content-wrapper{\n        header{\n            padding:0px 5px !important;\n        }\n    }\n\n    #designlist li{\n        height:150px !important;\n    }\n}\n\n \n\n#botinput-wrapper{\n    width:94%;\n    p.disclaimer{\n       color: #000000 !important;\n       font-size: 14px;\n        padding:0px 10px 0px;\n       font-family: sans-serif;\n       label span{\n        display: inline-block;\n        //background: #fff;\n        text-align: center;\n        padding: 10px;\n        color: rgb(13, 12, 9);\n       // box-shadow:0px 0px 4px rgba(85, 85, 85, 0.4);\n    }\n       .expan-down-arrow{\n        display: flex;\n        justify-content: center;\n        & a{\n          background-color:#fff;\n          padding:7px;\n          .fa{\n            font-size:1.5rem !important;\n          }\n        }\n       }\n    }\n}\n\n.bot-middle-content{\n    width: 100%;\n    max-width:960px;\n    margin: auto;\n}\n\n#template-title{\n    display: inline-flex;\n    width: 100%;\n    font-size:1rem;\n    \n    span:nth-child(1){\n        width:80%;\n        text-align: center;\n    }\n    span:nth-child(2){\n        width:20%;\n    }\n    .button{\n        border-color:#fff;\n        border-width: 0px;\n    }\n\n}\n#designlist-wrapper{\n    height:90vh;\n    overflow-y: auto;\n    padding:0px 20px;\n}\n\n@media screen and (max-width:640px) {\n    .chat-history-list{\n      left:0px;  \n      top:0px;\n    }\n}\n\n@media screen and (min-width:768px) and (max-width:960px) {\n    #chat-list-content{\n     padding: 1% 3% 0% 1% !important;\n    }\n    \n}\n \n "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
